import { CLEAR, FETCH_ASSET_REFERENCES } from './mutation-types'
import Vue from 'vue'

export default {
  [FETCH_ASSET_REFERENCES] (state, assetReferences) {
    state.assetReferences = {}
    for (let i = 0; i < assetReferences.length; ++i) {
      Vue.set(state.assetReferences, i, assetReferences[i])
    }
  },

  [CLEAR] (state) {
    state.assetReferences = {}
  }
}
